import styled from 'styled-components';

export const StyledButtonGroup = styled.div`
    & button {
        min-width: 135px !important;
    }
`
